import { List } from "./list/Index"
import { Setup } from "./setup/Index"

export const BranchProduct = ({match}) => {

    let loc = match.params.params

    if (loc === 'list') {
        return <List/>
    }else{
        return( 
            <>
                <Setup loc={loc}/>
            </>
        )
    }
}